import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { KO_SERVICES } from "@/data/ko-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ko/services";
const C = KO_SERVICES;

export const Route = createFileRoute("/ko/services")({
  head: () => ({
    meta: [
      { title: ctaTitle("방콕 한국어 리걸·공증·번역·비자 원스톱 | NYC Legal", "/ko/services", "th")},
      { name: "description", content: ctaDesc("방콕 Asok 한국어 데스크. 공증·인증 번역·아포스티유·국제결혼·비자·노동허가·법인 설립을 한국인 담당자가 한국어로 대응. Start with a free review before you file anything.", "/ko/services", "th")},
      { property: "og:title", content: ctaTitle("방콕 한국어 리걸 원스톱 | NYC Legal", "/ko/services", "th")},
      { property: "og:description", content: ctaDesc("태국 거주 한국인을 위한 종합 리걸 서비스. 카카오톡 무료 상담.", "/ko/services", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ko_KR" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/services" },
          { hreflang: "en", path: "/en/services" },
          { hreflang: "zh", path: "/zh/services" },
          { hreflang: "ja", path: "/ja/services" },
          { hreflang: "ko", path: "/ko/services" },
          { hreflang: "x-default", path: "/services" },
        ],
        "/services",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "LegalService",
        name: "NYC Legal — Korean Desk", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "KR"], inLanguage: "ko",
        priceRange: "฿1,500–฿50,000",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "ko",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "홈", item: `${SEO_SITE}/ko` },
          { "@type": "ListItem", position: 2, name: "서비스", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
